import ApiService from '@/services/ApiService';
import FiscalServiceLegacy from '@/services/FiscalServiceLegacy';
import TerminalService from '@/services/TerminalService';
import CashRegister from '@/models/CashRegister';

const CASH_REGISTER_KEY = 'cash-register-id';

const CashRegisterService = {

    /**
     * Set Cash Register
     */
    setCashRegister(cashRegister){
        this.setId(cashRegister.id);
        CashRegister.insert({ data: [cashRegister] })
        ApiService.setCashRegisterHeader()
        FiscalServiceLegacy.init()

        if(cashRegister.terminal) {
            TerminalService.setTerminal(cashRegister.terminal)
        }
    },

    /**
     * Set Cash Register
     */
    removeCashRegister(){
        this.removeId();
        ApiService.removeCashRegisterHeader()
    },

    /**
     * Get Cash Register Id
     */
    getId() {
        return AppStorage.local().getItem(CASH_REGISTER_KEY);
    },

    /**
     * Set Cash Register Id
     */
    setId(id) {
        AppStorage.local().setItem(CASH_REGISTER_KEY, id);
    },

    /**
     * Remove Cash Register Id
     */
    removeId() {
        AppStorage.local().deleteItem(CASH_REGISTER_KEY);
    },
};

export default CashRegisterService;

export { CashRegisterService };
